var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isH5 || _vm.isMini)?_c('mobile-page'):_c('pc-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }